import {connect} from 'react-redux';
import {getTranslation} from "../../../../reducers/common/localization";
import PriorConsentsList from "./PriorConsentsList";
import {
    getPriorConsentsList,
    loadingPriorConsents, onGetPriorConsents, resetPriorConsentsData, setFilterDate
} from "../../../../reducers/consent/priorConsents";
import {MODAL_REMOVE_PRIOR_CONSENT, showModal} from "../../../../reducers/common/activeModal";

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        loading: loadingPriorConsents(state),
        data: getPriorConsentsList(state),
        addingDisabled: false,
        editingDisabled: false
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(setFilterDate(null));
            dispatch(onGetPriorConsents());
        },
        onRemoveIconClick: () => dispatch(showModal({modalKey: MODAL_REMOVE_PRIOR_CONSENT})),
        onUnmount: () => dispatch(resetPriorConsentsData())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PriorConsentsList);



// WEBPACK FOOTER //
// ./src/components/consentManagement/consentsList/priorConsentsList/PriorConsentsList.container.js